import Request from './request'

const Servers  = {
  getServers (params, callback) {
    Request.post('servers', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getIPS (callback) {
    Request.post('servers/addresses', {}).then(callback).catch(this.bad_answer)
  },
  getAddressesHistory(callback) {
    Request.post('servers/addresses-history', {}).then(callback).catch(this.bad_answer)
  },
  saveIPS (params, callback) {
    Request.post('servers/save-addresses', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  //
  saveServer (params, callback) {
    Request.post('servers/save-main-server', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  addNewGroupServer (callback) {
    Request.post('servers/add-server-group').then(callback).catch(this.bad_answer)
  },
  deleteServerGroup (params, callback) {
    Request.post('servers/delete-server-group', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  GroupServer (callback) {
    Request.post('servers/server-group-list').then(callback).catch(this.bad_answer)
  },
  saveServerGroup (params, callback) {
    Request.post('servers/save-server-group', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  }
}

export default Servers
